import { SaleInvoiceService } from "@/api/services/transactionService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SaleInvoiceDetail {
  saleId: string;
  account: string;
  quantity: number;
  amount?: number;
  rate: number;
  gstTaxableValue: string;
  igstPer: string;
  sac: string;
  tds: string;
  tds1: string;
  isService: boolean;
  narration: string;
}

export interface SaleInvoicePayment {
  saleId: string;
  paymentId: string;
  account: string;
  amount: number;
  chequeNumber: string;
  bankName: string;
  chequedate: string;
}

export interface SaleInvoiceDocument {
  SaleId: string;
  Remark: string;
  File?: File;
  FileName: string;
  fileName: string;
  remark: string;
  saleId: string;
}

export interface SaleInvoiceInfo {
  saleId?: string;
  location: string;
  date: string;
  billDate: string;
  billTo: string;
  stateofReciever: string;
  stateOfSupplier: string;
  gstin: string;
  taxClassification: string;
  shipTo: string;
  poNo: string;
  poDate: string;
  eWayBillNo: string;
  paymentDueBy: string;
  saleInvoiceDetail: SaleInvoiceDetail[];
  saleInvoicePayment: SaleInvoicePayment[];
  saleDocument: SaleInvoiceDocument;
  totalAmount?: number;
}

interface TabState {
  activeTab: string;
}
interface SaleInvoiceFormState {
  info: SaleInvoiceInfo;
  editInfo: SaleInvoiceInfo;
  error: string | undefined;
}

const initialInfo: SaleInvoiceInfo = {
  saleId: "",
  location: "",
  date: "",
  billDate: "",
  billTo: "",
  stateofReciever: "",
  stateOfSupplier: "",
  gstin: "",
  taxClassification: "",
  shipTo: "",
  poNo: "",
  poDate: "",
  eWayBillNo: "",
  paymentDueBy: "",
  saleInvoiceDetail: [],
  saleInvoicePayment: [],
  saleDocument: {
    FileName: "",
    fileName: "",
    Remark: "",
    remark: "",
    SaleId: "",
    saleId: "",
  },
};

const initialState: SaleInvoiceFormState = {
  info: { ...initialInfo },
  editInfo: { ...initialInfo },
  error: "",
};

const tabInitialState: TabState = {
  activeTab: "1",
};

export const fetchSaleInvoice = createAsyncThunk<
  SaleInvoiceInfo,
  string,
  { rejectValue: string }
>("saleInvoice/fetchSaleInvoiceInfo", async (id, { rejectWithValue }) => {
  try {
    const response = await SaleInvoiceService.getById(id);
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message ?? "Failed to Fetch Information");
  }
});

const saleInvoiceSlice = createSlice({
  name: "saleInvoiceForm",
  initialState,
  reducers: {
    setSaleInvoiceInfomationData(
      state,
      action: PayloadAction<SaleInvoiceInfo>
    ) {
      state.info = action.payload;
    },
    setSaleInvoiceDetailData(
      state,
      action: PayloadAction<SaleInvoiceDetail[]>
    ) {
      state.info.saleInvoiceDetail = action.payload;
    },
    setSaleInvoicePaymentData(
      state,
      action: PayloadAction<SaleInvoicePayment[]>
    ) {
      state.info.saleInvoicePayment = action.payload;
    },
    setSaleInvoiceDocumentData(
      state,
      action: PayloadAction<SaleInvoiceDocument>
    ) {
      state.info.saleDocument = action.payload;
    },
    setSaleInvoiceTotalAmount(state, action: PayloadAction<number>) {
      state.info.totalAmount = action.payload;
    },
    resetsaleInvoiceForm(state) {
      state.info = { ...initialInfo };
      state.editInfo = { ...initialInfo };
      state.error = "";
    },
    setEditSaleInvoiceInfomationData(
      state,
      action: PayloadAction<SaleInvoiceInfo>
    ) {
      state.editInfo = action.payload;
    },
    setEditSaleInvoiceDetailData(
      state,
      action: PayloadAction<SaleInvoiceDetail[]>
    ) {
      state.editInfo.saleInvoiceDetail = action.payload;
    },
    setEditSaleInvoicePaymentData(
      state,
      action: PayloadAction<SaleInvoicePayment[]>
    ) {
      state.editInfo.saleInvoicePayment = action.payload;
    },
    setEditSaleInvoiceDocumentData(
      state,
      action: PayloadAction<SaleInvoiceDocument>
    ) {
      state.editInfo.saleDocument = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSaleInvoice.pending, (state) => {
        state.error = undefined;
      })
      .addCase(fetchSaleInvoice.fulfilled, (state, action) => {
        state.editInfo = action.payload;
      })
      .addCase(fetchSaleInvoice.rejected, (state, action) => {
        state.error =
          typeof action.payload == "string"
            ? action.payload
            : "unknown error occuredF";
      });
  },
});

const invoiceTabSlice = createSlice({
  name: "saleInvoiceTab",
  initialState: tabInitialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<string>) {
      state.activeTab = action.payload;
      console.log(action.payload)
    },
    resetActiveTab(state) {
      state.activeTab = "1";
    },
  },
});
export const {
  setSaleInvoiceInfomationData,
  setSaleInvoiceDetailData,
  setSaleInvoicePaymentData,
  setSaleInvoiceDocumentData,
  setSaleInvoiceTotalAmount,
  setEditSaleInvoiceInfomationData,
  setEditSaleInvoiceDetailData,
  setEditSaleInvoicePaymentData,
  setEditSaleInvoiceDocumentData,
  resetsaleInvoiceForm,
} = saleInvoiceSlice.actions;
export const { setActiveTab, resetActiveTab } = invoiceTabSlice.actions;

export const saleInvoiceTabReducer = invoiceTabSlice.reducer;
export const saleInvoiceReducer = saleInvoiceSlice.reducer;
